import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Utils } from '../../utils/utils';
import InlineElementUtils from '../editor-utils/inline-element-utils';
import Modal from '../../components/modal-portal';

var Image = /*#__PURE__*/function (_React$Component) {
  _inherits(Image, _React$Component);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);

    _this.startMove = function (e) {
      e.stopPropagation();

      _this.setState({
        isResizing: true
      });

      window.addEventListener('mousemove', _this.handleMove);
      window.addEventListener('mouseup', _this.stopMove);
    };

    _this.stopMove = function (e) {
      e.stopPropagation();
      e.preventDefault();
      window.removeEventListener('mousemove', _this.handleMove);
      var node = _this.props.node;

      _this.inlineElementUtils.adjustImageSize({
        width: _this.state.width,
        src: node.data.src
      });

      _this.setState({
        isResizing: false
      });

      window.removeEventListener('mouseup', _this.stopMove);
    };

    _this.handleMove = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var changeX;
      changeX = e.clientX - _this.refs.resizer.getBoundingClientRect().left - 5;
      var imageWidth = _this.refs.image.width + changeX;

      if (imageWidth >= _this.editor.offsetWidth) {
        return;
      }

      if (imageWidth < 20) {
        return;
      }

      _this.setState({
        width: imageWidth
      });
    };

    _this.setFullScreen = function (event) {
      event.stopPropagation();
      var src = _this.props.node.data.src;

      _this.toggleBigImage(event, src);
    };

    _this.toggleBigImage = function (event, src) {
      event.preventDefault();

      _this.setState({
        isShowBigImage: !_this.state.isShowBigImage
      });

      _this.imgSrc = src;
    };

    _this.renderBigImage = function () {
      return /*#__PURE__*/React.createElement(BigImage, {
        bigImageSrc: _this.imgSrc,
        toggleBigImage: _this.toggleBigImage
      });
    };

    _this.state = {
      width: null,
      isResizing: false,
      isShowBigImage: false
    };
    _this.inlineElementUtils = new InlineElementUtils(window.editor);
    return _this;
  }

  _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.editor = document.querySelector('.editor-component');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refs.resizer = null;
      this.refs.image = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attributes = _this$props.attributes,
          node = _this$props.node,
          isSelected = _this$props.isSelected,
          children = _this$props.children;
      var isResizing = this.state.isResizing;
      var data = node.data;
      var src = data.src;

      if (/^\.\.\/*/.test(src) || /^\.\/*/.test(src)) {
        var _window$editor$editor = window.editor.editorApi,
            filePath = _window$editor$editor.filePath,
            serviceUrl = _window$editor$editor.serviceUrl,
            repoID = _window$editor$editor.repoID;
        var originalPath = filePath.slice(0, filePath.lastIndexOf('/')) + '/' + src;
        src = serviceUrl + '/lib/' + repoID + '/file/' + Utils.pathNormalize(originalPath) + '?raw=1';
      }

      var dom = /*#__PURE__*/React.createElement("span", Object.assign({
        className: "seafile-ed-image"
      }, attributes), isSelected || isResizing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        className: "seafile-ed-image-inResizing",
        draggable: false,
        src: src,
        width: this.state.width || data.width,
        alt: ' ',
        ref: "image"
      }), this.state.isResizing ? /*#__PURE__*/React.createElement("span", {
        contentEditable: false,
        className: "image-size"
      }, /*#__PURE__*/React.createElement("span", null, this.props.t('width'), ':', parseInt(this.state.width || this.refs.image.clientWidth)), /*#__PURE__*/React.createElement("span", null, "\xA0\xA0"), /*#__PURE__*/React.createElement("span", null, this.props.t('height'), ':', this.refs.image.clientHeight)) : null, /*#__PURE__*/React.createElement("span", {
        ref: "resizer",
        onMouseDown: this.startMove,
        className: 'image-resizer'
      }), isSelected && /*#__PURE__*/React.createElement("span", {
        contentEditable: false,
        onClick: this.setFullScreen,
        className: "image-full-button"
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-fullscreen'
      }), /*#__PURE__*/React.createElement("span", {
        className: 'image-tooltip'
      }, this.props.t('Full_screen')))) : /*#__PURE__*/React.createElement("img", {
        width: data.width || '',
        draggable: false,
        src: src,
        alt: ' ',
        ref: "image"
      }), children, this.state.isShowBigImage && this.renderBigImage());
      return src ? dom : /*#__PURE__*/React.createElement("span", attributes, "Loading...");
    }
  }]);

  return Image;
}(React.Component);

var BigImage = /*#__PURE__*/function (_React$Component2) {
  _inherits(BigImage, _React$Component2);

  var _super2 = _createSuper(BigImage);

  function BigImage() {
    _classCallCheck(this, BigImage);

    return _super2.apply(this, arguments);
  }

  _createClass(BigImage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
        className: 'big-image-cover',
        onClick: function onClick(event) {
          return _this2.props.toggleBigImage(event);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: 'big-image-container'
      }, /*#__PURE__*/React.createElement("img", {
        src: this.props.bigImageSrc,
        alt: ""
      })), /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(event) {
          return _this2.props.toggleBigImage(event);
        },
        className: 'image-container-close'
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-close'
      }))));
    }
  }]);

  return BigImage;
}(React.Component);

export default withTranslation('seafile-editor')(Image);